import {useContext, useRef} from 'react';
import {Button} from '@cvent/carina/components/Button';
import {Modal} from '@cvent/carina/components/Modal';
import {DismissButton} from '@cvent/carina/components/ScrollViewWithBars';
import {globalUIContext} from '../../utils/global-ui-helpers';

type SuspendedModalProps = {
  handleClose: () => void;
};

const SuspendedModal = ({handleClose}: SuspendedModalProps) => {
  const headerRef = useRef<HTMLHeadingElement | null>(null);
  const {isMobile} = useContext(globalUIContext);

  return (
    <Modal
      isOpen
      format={isMobile ? 'sm' : 'md'}
      onDismiss={handleClose}
      testID="suspended-modal"
      aria-labelledby="suspended-modal-title"
    >
      <div className="flex flex-col w-full sm:w-[561px] max-w-full">
        <div className="mx-6 mt-6 mb-0 flex items-start justify-between">
          <h1
            id="suspended-modal-title"
            ref={headerRef}
            tabIndex={-1}
            className="text-[24px] font-normal leading-[var(--carina-line-height-tight)] text-[#1c2430]"
          >
            Welcome back!
          </h1>
          <DismissButton aria-label="Dismiss" onClick={handleClose} />
        </div>

        <div className="mx-6 my-4 text-sm leading-[var(--carina-line-height-normal)] text-[#69727f]">
          <p>
            Your account has been archived, but no worries - we can help get you
            reactivated.
          </p>
          <p className="mt-4">
            Contact our support team,{' '}
            <a
              aria-label="socialtables support email link"
              href="mailto:ST.support@cvent.com"
              className="text-[var(--carina-link-color,#006ae1)] underline"
            >
              ST.support@cvent.com
            </a>
            , or call{' '}
            <a
              aria-label="socialtables support phone number"
              href="tel:866-318-4357"
              className="text-[var(--carina-link-color,#006ae1)] underline"
            >
              866-318-4357
            </a>
            . Our phone support is available Monday through Friday, from 9 am to
            10 pm ET.
          </p>
        </div>

        <div className="mx-6 my-4 flex justify-end">
          <Button
            text="Close"
            onClick={handleClose}
            type="button"
            appearance="lined"
          />
        </div>
      </div>
    </Modal>
  );
};

export default SuspendedModal;
